// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + chunkId + "." + {"80":"9fa70783db114338db02","147":"5c45773df862d9a0c459","528":"d063de59f61efaed9c85","813":"83355a5558bb08a64e2f"}[chunkId] + ".js";
};